import React from 'react';
import { Box, Text, Badge, Group, Divider, RingProgress, Tooltip, Center, ActionIcon, rem, Loader } from '@mantine/core';
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react';

export interface ProgressStep {
  label: string;
  status: 'completed' | 'current' | 'upcoming';
  progress?: number;
  isComplete?: boolean;
}

interface ProgressTrackerProps {
  steps: ProgressStep[];
  progress?: boolean;
}

const ProgressTracker: React.FC<ProgressTrackerProps> = ({ steps, progress }) => {
  return (
    <Box sx={{ width: '100%',display:"flex",justifyContent:"center" ,}}>
      <Group spacing="xs" align="center" noWrap>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <Group spacing="xs" align="center" noWrap>
              <Box sx={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {step.progress !== undefined && step.progress >= 0 ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
                    {step?.status!=='completed' &&step?.progress!==0 && step?.progress!==100? <Loader/>: <RingProgress
                      sections={[{ value: step.progress, color: step.progress === 100 ? 'green' : 'blue' }]}
                      size={40}
                      thickness={4}
                      label={step?.progress===100?
                        <Center>
                        <ActionIcon color={step.isComplete?"teal":"yellow"} variant="light" radius="xl" size="xl">
                          {step.isComplete &&<IconCheck style={{ width: rem(22), height: rem(22) }} />}
                          {!step.isComplete &&<IconAlertTriangle style={{ width: rem(22), height: rem(22) }} />}

                        </ActionIcon>
                      </Center>:
            
                        <Text size="xs" align="center">
                          {index + 1}
                        </Text>
                      }
                    />
            }
                          <Text
                      color={
                        step.progress === 0? 'gray' :
                        step.progress === 100 && step.isComplete ? 'green' :
                        step.progress === 100 && !step.isComplete ? 'yellow' :
                        step.progress > 0 ? 'blue' : 'black'
                      }
                      size="sm"
                      sx={{
                        textAlign: 'center',
                        wordBreak: 'break-word',
                        '&::after': {
                          content: '" "',
                          display: 'block',
                        },
                        '&::first-line': {
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                        }
                      }}
                    >
                      {step.label.split(' ').slice(0, 1).join(' ')}
                      <br />
                      {step.label.split(' ').slice(1).join(' ')}
                    </Text>
                  </Box>
                ) : (
                  <Badge
                    color={step.status === 'completed'? 'green' : step.status==='current' ? 'blue' : 'gray'}
                    variant={step.progress === 100 ? 'outline' : 'filled'}
                    radius="xl"
                    size="lg"
                  >
                    {index + 1}
                  </Badge>
                )}
              </Box>
              {index < steps.length - 1 && progress && (
                <Box sx={{ display:"flex",alignItems:"flex-start" ,}}>
                  <Divider
                    size="sm"
                    variant={step.progress === 100 ? 'dotted' : step.progress??0 ? 'dotted' : 'solid'}
                    sx={{
                      borderColor: step.progress === 100 ? '#66C085' : step.progress??0 > 0 ? 'blue' : '#e0e0e0',
                      width: '46px',
                      flexShrink: 0,
                      margin: '0 4px',
                      marginBottom:"45px"
                    }}
                  />
                </Box>
              )}
            </Group>
            {!progress && (
              <Tooltip
                label={step.label}
                position="top"
                withArrow
                multiline
                width={200}
                disabled={step.label.length <= 25}
              >
                <Text
                  color={
                    step.status === 'upcoming' ? 'gray' :
                    step.status === 'completed' ? 'green' :
                    step.status === 'current' ? 'blue' : 'black'
                  }
                  size="sm"
                  sx={{
                    maxWidth: '120px',
                    minWidth: '50px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flexShrink: 0,
                  }}
                >
                  {step.label}
                </Text>
              </Tooltip>
            )}
            {index < steps.length - 1 && !progress && (
              <Divider
                size="sm"
                variant={step.status === 'current' ? 'dotted' : step.status === 'upcoming' ? 'dotted' : 'solid'}
                sx={{
                  borderColor: step.status === 'completed' ? '#66C085' : step.status === 'current' ? 'blue' : '#e0e0e0',
width: '60px',                  flexShrink: 0,
                  margin: '0 4px',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Group>
    </Box>
  );
};

export default ProgressTracker;
